"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkStatus = exports.UOMDisplayName = exports.UOM = exports.OwnerType = exports.ExtractionMethod = exports.ProductType = exports.ProductAttributesDisplayName = exports.CatalogField = exports.ProductField = exports.ProductDetailsField = exports.ProductAttributesField = exports.Classification = exports.CatalogProductStatus = exports.ActionTypeDisplayName = exports.ActionType = void 0;
var ActionType;
(function (ActionType) {
    ActionType["ACTIVATE_IN_CATALOG"] = "ACTIVATE_IN_CATALOG";
    ActionType["ADD_TO_CATALOG"] = "ADD_TO_CATALOG";
    ActionType["CREATE"] = "CREATE";
    ActionType["DEACTIVATE_IN_CATALOG"] = "DEACTIVATE_IN_CATALOG";
    ActionType["DELETE"] = "DELETE";
    ActionType["LINK"] = "LINK";
    ActionType["MERGE"] = "MERGE";
    ActionType["REMOVE_FROM_CATALOG"] = "REMOVE_FROM_CATALOG";
    ActionType["UNLINK"] = "UNLINK";
    ActionType["UPDATE_IN_CATALOG"] = "UPDATE_IN_CATALOG";
    ActionType["UPDATE"] = "UPDATE";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var ActionTypeDisplayName;
(function (ActionTypeDisplayName) {
    ActionTypeDisplayName["ACTIVATE_IN_CATALOG"] = "Made Active in Catalog";
    ActionTypeDisplayName["ADD_TO_CATALOG"] = "Added to Catalog";
    ActionTypeDisplayName["CREATE"] = "Created Product";
    ActionTypeDisplayName["DEACTIVATE_IN_CATALOG"] = "Made Inactive in Catalog";
    ActionTypeDisplayName["DELETE"] = "Deleted Product";
    ActionTypeDisplayName["LINK"] = "Linked Product";
    ActionTypeDisplayName["MERGE"] = "Merged Product";
    ActionTypeDisplayName["REMOVE_FROM_CATALOG"] = "Removed from Catalog";
    ActionTypeDisplayName["UNLINK"] = "Unlinked Product";
    ActionTypeDisplayName["UPDATE_IN_CATALOG"] = "Updated in Catalog";
    ActionTypeDisplayName["UPDATE"] = "Updated Product";
})(ActionTypeDisplayName = exports.ActionTypeDisplayName || (exports.ActionTypeDisplayName = {}));
var CatalogProductStatus;
(function (CatalogProductStatus) {
    CatalogProductStatus["ACTIVE"] = "ACTIVE";
    CatalogProductStatus["DELETED"] = "DELETED";
    CatalogProductStatus["DEACTIVATED"] = "DEACTIVATED";
})(CatalogProductStatus = exports.CatalogProductStatus || (exports.CatalogProductStatus = {}));
var Classification;
(function (Classification) {
    Classification["HYBRID"] = "HYBRID";
    Classification["INDICA"] = "INDICA";
    Classification["INDICA_SATIVA"] = "I/S";
    Classification["SATIVA"] = "SATIVA";
    Classification["SATIVA_INDICA"] = "S/I";
    Classification["KUSH"] = "KUSH";
    Classification["CBD"] = "CBD";
    Classification["NONE"] = "NONE";
})(Classification = exports.Classification || (exports.Classification = {}));
var ProductAttributesField;
(function (ProductAttributesField) {
    ProductAttributesField["EFFECT"] = "effect";
    ProductAttributesField["FLAVOR"] = "flavor";
    ProductAttributesField["GENERAL"] = "general";
    ProductAttributesField["INGREDIENT"] = "ingredient";
    ProductAttributesField["INTERNAL"] = "internal";
})(ProductAttributesField = exports.ProductAttributesField || (exports.ProductAttributesField = {}));
var ProductDetailsField;
(function (ProductDetailsField) {
    ProductDetailsField["CBD_MG"] = "cbdMg";
    ProductDetailsField["DOSE_CBD_MG"] = "doseCbdMg";
    ProductDetailsField["DOSE_THC_MG"] = "doseThcMg";
    ProductDetailsField["DOSES"] = "doses";
    ProductDetailsField["EXTRACTION_METHOD"] = "extractionMethod";
    ProductDetailsField["GROSS_WEIGHT"] = "grossWeight";
    ProductDetailsField["NET_WEIGHT"] = "netWeight";
    ProductDetailsField["STRAIN"] = "strain";
    ProductDetailsField["THC_MG"] = "thcMg";
    ProductDetailsField["TOTAL_WEIGHT"] = "totalWeight";
    ProductDetailsField["TOTAL_CONCENTRATE_WEIGHT"] = "totalConcentrateWeight";
})(ProductDetailsField = exports.ProductDetailsField || (exports.ProductDetailsField = {}));
var ProductField;
(function (ProductField) {
    ProductField["AMOUNT"] = "amount";
    ProductField["ATTRIBUTES"] = "attributes";
    ProductField["BRAND_NAME"] = "brandName";
    ProductField["CANNABIS"] = "cannabis";
    ProductField["CATALOG_PRODUCT_ID"] = "catalogProductId";
    ProductField["CLASSIFICATION"] = "classification";
    ProductField["DESCRIPTIONS"] = "descriptions";
    ProductField["DETAILS"] = "details";
    ProductField["DISPLAY_NAME"] = "displayName";
    ProductField["ECOMMERCE_NAME"] = "eCommerceName";
    ProductField["EXTERNAL_ID"] = "externalId";
    ProductField["ID"] = "id";
    ProductField["IMAGES"] = "images";
    ProductField["LINKED_TO"] = "linkedTo";
    ProductField["MSRP"] = "msrp";
    ProductField["NAME"] = "name";
    ProductField["OWNER_ID"] = "ownerId";
    ProductField["OWNER_TYPE"] = "ownerType";
    ProductField["PRICE"] = "price";
    ProductField["PRODUCT_SHORT_CODE"] = "productShortCode";
    ProductField["SEARCH_VECTOR"] = "searchVector";
    ProductField["SIZE"] = "size";
    ProductField["SKU"] = "sku";
    ProductField["STATUS"] = "status";
    ProductField["SUBTYPE"] = "subtype";
    ProductField["TPC"] = "tpc";
    ProductField["TYPE"] = "type";
    ProductField["UOM"] = "uom";
    ProductField["UPC"] = "upc";
    ProductField["UUID"] = "uuid";
    ProductField["UPDATED_AT"] = "updatedAt";
    ProductField["VISIBLE"] = "visible";
    ProductField["PRODUCT_BARCODES"] = "productBarcodes";
    ProductField["PRODUCT_ID"] = "productId";
    ProductField["PRODUCT_TYPE"] = "productType";
    ProductField["IMAGE_ID"] = "imageId";
    ProductField["HIDE_FROM_MENU"] = "hideFromMenu";
    ProductField["RELATIVE_PATH"] = "relativePath";
    ProductField["PRICING"] = "pricing";
    ProductField["PRICE_TIER"] = "priceTier";
    ProductField["UNIT_OF_MEASURE"] = "unitOfMeasure";
    ProductField["MENU_TITLE"] = "menuTitle";
    ProductField["MG_PER_DOSE"] = "mgPerDose";
})(ProductField = exports.ProductField || (exports.ProductField = {}));
var CatalogField;
(function (CatalogField) {
    CatalogField["CATALOG_ID"] = "catalogId";
})(CatalogField = exports.CatalogField || (exports.CatalogField = {}));
var ProductAttributesDisplayName;
(function (ProductAttributesDisplayName) {
    ProductAttributesDisplayName["AMOUNT"] = "Amount";
    ProductAttributesDisplayName["ATTRIBUTES"] = "Attributes";
    ProductAttributesDisplayName["BRAND_NAME"] = "Brand";
    ProductAttributesDisplayName["CANNABIS"] = "Cannabis Product";
    ProductAttributesDisplayName["CBD_MG"] = "Milligrams CBD";
    ProductAttributesDisplayName["CLASSIFICATION"] = "Classification";
    ProductAttributesDisplayName["DESCRIPTIONS"] = "Description";
    ProductAttributesDisplayName["DETAILS"] = "Details";
    ProductAttributesDisplayName["DISPLAY_NAME"] = "Display Name";
    ProductAttributesDisplayName["DOSE_CBD_MG"] = "Milligrams CBD per Dose";
    ProductAttributesDisplayName["DOSE_THC_MG"] = "Milligrams THC per Dose";
    ProductAttributesDisplayName["DOSES"] = "Doses";
    ProductAttributesDisplayName["ECOMMERCE_NAME"] = "Menu Title";
    ProductAttributesDisplayName["EFFECT"] = "Effects";
    ProductAttributesDisplayName["EXTERNAL_ID"] = "External Id";
    ProductAttributesDisplayName["EXTRACTION_METHOD"] = "Extraction Method";
    ProductAttributesDisplayName["FLAVOR"] = "Flavors";
    ProductAttributesDisplayName["GENERAL"] = "General Attributes";
    ProductAttributesDisplayName["GROSS_WEIGHT"] = "Gross Weight";
    ProductAttributesDisplayName["ID"] = "Unique Product Id";
    ProductAttributesDisplayName["IMAGES"] = "Images";
    ProductAttributesDisplayName["INGREDIENT"] = "Ingredients";
    ProductAttributesDisplayName["INTERNAL"] = "Internal Tags";
    ProductAttributesDisplayName["LINKED_TO"] = "Linked Brand Product";
    ProductAttributesDisplayName["MSRP"] = "MSRP";
    ProductAttributesDisplayName["NAME"] = "Name";
    ProductAttributesDisplayName["NET_WEIGHT"] = "Net Weight";
    ProductAttributesDisplayName["OWNER_ID"] = "Owner Id";
    ProductAttributesDisplayName["OWNER_TYPE"] = "Owner Type";
    ProductAttributesDisplayName["PRICE"] = "Price";
    ProductAttributesDisplayName["PRODUCT_SHORT_CODE"] = "Short Code";
    ProductAttributesDisplayName["SIZE"] = "Size";
    ProductAttributesDisplayName["SKU"] = "SKU";
    ProductAttributesDisplayName["STATUS"] = "Status";
    ProductAttributesDisplayName["STRAIN"] = "Strain";
    ProductAttributesDisplayName["SUBTYPE"] = "Subtype";
    ProductAttributesDisplayName["THC_MG"] = "Milligrams THC";
    ProductAttributesDisplayName["TOTAL_WEIGHT"] = "Total Flower Weight";
    ProductAttributesDisplayName["TOTAL_CONCENTRATE_WEIGHT"] = "Total Concentrate Weight";
    ProductAttributesDisplayName["TPC"] = "Treez Product Code";
    ProductAttributesDisplayName["TYPE"] = "Type";
    ProductAttributesDisplayName["UOM"] = "UOM";
    ProductAttributesDisplayName["UPC"] = "UPC";
    ProductAttributesDisplayName["UUID"] = "Sell Treez Id";
    ProductAttributesDisplayName["VISIBLE"] = "Show on Menu";
})(ProductAttributesDisplayName = exports.ProductAttributesDisplayName || (exports.ProductAttributesDisplayName = {}));
var ProductType;
(function (ProductType) {
    ProductType["BEVERAGE"] = "BEVERAGE";
    ProductType["CARTRIDGE"] = "CARTRIDGE";
    ProductType["CBD"] = "CBD";
    ProductType["EDIBLE"] = "EDIBLE";
    ProductType["EXTRACT"] = "EXTRACT";
    ProductType["FLOWER"] = "FLOWER";
    ProductType["MERCH"] = "MERCH";
    ProductType["MISC"] = "MISC";
    ProductType["NON_INV"] = "NON-INV";
    ProductType["PILL"] = "PILL";
    ProductType["PLANT"] = "PLANT";
    ProductType["PREROLL"] = "PREROLL";
    ProductType["TINCTURE"] = "TINCTURE";
    ProductType["TOPICAL"] = "TOPICAL";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
var ExtractionMethod;
(function (ExtractionMethod) {
    ExtractionMethod["SOLVENT"] = "Solvent";
    ExtractionMethod["SOLVENTLESS"] = "Solventless";
})(ExtractionMethod = exports.ExtractionMethod || (exports.ExtractionMethod = {}));
var OwnerType;
(function (OwnerType) {
    OwnerType["BRAND"] = "brand";
    OwnerType["ORG"] = "organization";
    OwnerType["STORE"] = "store";
})(OwnerType = exports.OwnerType || (exports.OwnerType = {}));
var UOM;
(function (UOM) {
    UOM["EACH"] = "each";
    UOM["FLOZ"] = "fl-oz";
    UOM["G"] = "g";
    UOM["GAL"] = "gal";
    UOM["KG"] = "kg";
    UOM["L"] = "l";
    UOM["LB"] = "lb";
    UOM["MG"] = "mg";
    UOM["ML"] = "ml";
    UOM["OZ"] = "oz";
    UOM["PT"] = "pt";
    UOM["QT"] = "qt";
})(UOM = exports.UOM || (exports.UOM = {}));
var UOMDisplayName;
(function (UOMDisplayName) {
    UOMDisplayName["EACH"] = "Each";
    UOMDisplayName["FLOZ"] = "Fluid Ounces";
    UOMDisplayName["G"] = "Grams";
    UOMDisplayName["GAL"] = "Gallons";
    UOMDisplayName["KG"] = "Kilograms";
    UOMDisplayName["L"] = "Liters";
    UOMDisplayName["LB"] = "Pounds";
    UOMDisplayName["MG"] = "Milligrams";
    UOMDisplayName["ML"] = "Milliliters";
    UOMDisplayName["OZ"] = "Ounces";
    UOMDisplayName["PT"] = "Pint";
    UOMDisplayName["QT"] = "Quart";
})(UOMDisplayName = exports.UOMDisplayName || (exports.UOMDisplayName = {}));
var LinkStatus;
(function (LinkStatus) {
    LinkStatus["LINKED"] = "linked";
    LinkStatus["NOT_LINKED"] = "notLinked";
    LinkStatus["SUGGESTED_LINK"] = "suggestedLink";
    LinkStatus["DEPRECATED"] = "deprecated";
})(LinkStatus = exports.LinkStatus || (exports.LinkStatus = {}));
;
//# sourceMappingURL=data:application/json;base64,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